import { Link } from "react-router-dom";
import type { Movie } from "@/utils/movies";

interface RelatedMoviesProps {
  movies: Movie[];
}

export default function RelatedMovies({ movies }: RelatedMoviesProps) {
  return (
    <aside className="lg:sticky lg:top-24">
      <h2 className="font-heading font-bold text-lg text-foreground-50 flex items-center gap-2 mb-4">
        <span className="w-1 h-5 rounded-full bg-accent-500 inline-block" />
        相关推荐
      </h2>
      <div className="flex flex-col gap-3">
        {movies.map((movie) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group flex items-center gap-3 p-2.5 bg-background-100 border border-background-200/60 rounded-lg hover:border-accent-500/60 transition-colors"
          >
            <span className="w-14 h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
              <img
                src={movie.poster}
                alt={`${movie.title} 封面`}
                title={`${movie.title} 影视内容`}
                className="w-full h-full object-cover object-top"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold text-foreground-50 truncate group-hover:text-accent-500 transition-colors">
                {movie.title}
              </span>
              <span className="block text-xs text-foreground-500 mt-1 truncate">
                {movie.type} · {movie.region} · {movie.year}
              </span>
              <span className="block text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
                {movie.genres.join(" / ")}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </aside>
  );
}